import React from 'react';

import './SoftDisk.scss';

const SoftDisk = () : JSX.Element => {
  return (
    <div className="soft-disk" />
  );
};

export default SoftDisk;
